<section class="hero-section">
  <div class="hero-container">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">{{ title }}</h1>
        <h2 class="hero-subtitle">{{ subtitle }}</h2>
        <p class="hero-description">
          Empower your teaching with digital tools and resources that provide
          <strong>impactful learning experiences</strong> and
          <strong>improve student outcomes</strong>, all designed to meet the dynamic needs of
          educators and learners.
        </p>
        <div class="search-bar">
          <input
            type="text"
            placeholder="Search by ISBN, Title, Author, or Keyword"
            class="search-input"
          />
          <button class="search-button" type="submit">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
